<div class="filter-container">
    <app-search-inline [placeholderStr]="'Search Custom Dimensions'" (keywordChange)="search($event)" data-cy="search-custom-metric-inline-wrapper"></app-search-inline>
    <button mat-raised-button class="rubii-btn add-btn" color="primary" data-cy="report-button-dashboard-create" (click)="create()"><mat-icon [inline]="true">add</mat-icon> Create</button>
</div>

<div class="rubii-table">
    <table style="max-width: 100%">
        <thead>
            <tr>
                <th class="report-name-th">Name</th>
                <th class="date-range-th">Date Created</th>
                <th class="last-modified-th">Last Modified</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let dimension of customDimensions">
                <td class="report-name-td" [ngClass]="dimension.status === CustomDimensionStatus.Archived ? 'archived' : undefined">
                    <div>
                        <div class="report-name">
                            {{ dimension.name }}
                        </div>
                        <div class="icons">
                            <div
                                class="rb rb-icon-edit img"
                                [matTooltip]="'Edit'"
                                *ngIf="dimension.status === CustomDimensionStatus.Active"
                                data-cy="button-custom-metric-edit"
                                (click)="edit(dimension._id)"
                            ></div>
                            <div
                                class="rb rb-icon-copy img"
                                [matTooltip]="'Clone'"
                                *ngIf="dimension.status === CustomDimensionStatus.Active"
                                data-cy="button-custom-metric-clone"
                                (click)="clone(dimension._id)"
                            ></div>
                            <div
                                class="rb rb-icon-archive img"
                                [matTooltip]="'Archive'"
                                *ngIf="dimension.status === CustomDimensionStatus.Active"
                                data-cy="button-custom-metric-archive"
                                (click)="archive(dimension._id)"
                            ></div>
                            <div
                                class="rb rb-icon-unarchive img"
                                [matTooltip]="'Enable'"
                                *ngIf="dimension.status === CustomDimensionStatus.Archived"
                                data-cy="button-custom-metric-enable"
                                (click)="enable(dimension._id)"
                            ></div>
                        </div>
                    </div>
                </td>
                <td class="date-range-td" [ngClass]="dimension.status === CustomDimensionStatus.Archived ? 'archived' : undefined">
                    {{ dimension.createdate | date : format : timezone }}
                </td>
                <td class="last-modified-td" [ngClass]="dimension.status === CustomDimensionStatus.Archived ? 'archived' : undefined">
                    {{ dimension.updatedate | date : format : timezone }}
                </td>
            </tr>

            <tr>
                <td colspan="6">
                    <mat-paginator
                        color="primary"
                        (page)="pageChanged($event)"
                        [length]="page.total"
                        [pageSize]="page.pageSize"
                        showFirstLastButtons="true"
                        [pageIndex]="page.pageId - 1"
                        [pageSizeOptions]="[5, 10, 25, 100]"
                    >
                    </mat-paginator>
                </td>
            </tr>
        </tbody>
    </table>
</div>
